import { useEffect, useState } from 'react'
import { usePageMeta } from '@/hooks/usePageMeta'
import api from '@/services/api'
import { Settings } from '@/types'

function MentionsLegales() {
  usePageMeta({
    title: 'Mentions légales',
  })

  const [settings, setSettings] = useState<Settings | null>(null)

  useEffect(() => {
    api.get<Settings>('/settings')
      .then(setSettings)
      .catch(err => console.error('Failed to load settings:', err))
  }, [])

  return (
    <div className="container" style={{ padding: '2rem 0' }}>
      <h1>Mentions légales</h1>

      <section style={{ marginTop: '2rem' }}>
        <h2>1. Éditeur du site</h2>
        <p>
          Le site <strong>Avenir Théopolitain 2026</strong> est édité par l'association de campagne "Avenir Théopolitain 2026".
        </p>
        <p>
          <strong>Responsable de la publication :</strong> {settings?.responsable_publication || 'Avenir Théopolitain'}<br />
          <strong>Contact :</strong> {settings?.contact_email || 'contact@avenirtheropolitain.fr'}
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>2. Hébergement</h2>
        <p>
          Le site est hébergé par :
        </p>
        <p>
          <strong>O2Switch</strong><br />
          SARL au capital de 100 000 €<br />
          RCS Clermont-Ferrand 510 909 807<br />
          Siège social : 222-224 Boulevard Gustave Flaubert, 63000 Clermont-Ferrand, France<br />
          Téléphone : 04 44 44 60 40<br />
          Site web : <a href="https://www.o2switch.fr" target="_blank" rel="noopener noreferrer">www.o2switch.fr</a>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>3. Conception et développement</h2>
        <p>
          Le site a été conçu et développé par :
        </p>
        <p>
          <strong>Del-com</strong><br />
          Site web : <a href="https://del-com.pro/" target="_blank" rel="noopener noreferrer">del-com.pro</a>
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>4. Propriété intellectuelle</h2>
        <p>
          L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, etc.) est la propriété exclusive de l'association "Avenir Théopolitain 2026" ou de ses partenaires, sauf mention contraire.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de l'association.
        </p>
        <p>
          Les marques, logos et signes distinctifs reproduits sur ce site sont la propriété de leurs titulaires respectifs.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>5. Données personnelles</h2>
        <p>
          Les informations recueillies via le formulaire de contact font l'objet d'un traitement informatique destiné à répondre aux demandes des visiteurs.
        </p>
        <p>
          Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
        </p>
        <p>
          Pour exercer ces droits, vous pouvez nous contacter à l'adresse : {settings?.contact_email || 'contact@avenirtheropolitain.fr'}
        </p>
        <p>
          Pour plus d'informations sur la gestion de vos données personnelles, consultez notre <a href="/politique-confidentialite">Politique de confidentialité</a>.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>6. Cookies</h2>
        <p>
          Le site utilise uniquement des cookies de session strictement nécessaires au fonctionnement du back-office administratif. Aucun cookie de suivi ou analytique n'est déposé sur votre navigateur lors de la navigation sur le site public.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>7. Responsabilité</h2>
        <p>
          L'association "Avenir Théopolitain 2026" s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
        </p>
        <p>
          L'association décline toute responsabilité en cas de dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
        </p>
        <p>
          Les liens hypertextes présents sur le site peuvent renvoyer vers des sites externes. L'association ne saurait être tenue responsable du contenu de ces sites tiers.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>8. Droit applicable</h2>
        <p>
          Le présent site et les présentes mentions légales sont régis par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
        </p>
      </section>

      <section style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <p>
          <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
        </p>
      </section>
    </div>
  )
}

export default MentionsLegales
